import {
	getDeliveryCompanies,
	getDeliveryPacks,
	postManualDeliver,
	postUpdateDelivery,
	postCompensateDeliver,
} from "../../../api/wxshop/delivery.js";

let modules = {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		getDeliveryCompaniesAction(conText, payload) {
			getDeliveryCompanies(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getDeliveryPacksAction(conText, payload) {
			getDeliveryPacks(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postManualDeliverAction(conText, payload) {
			postManualDeliver(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postUpdateDeliveryAction(conText, payload) {
			postUpdateDelivery(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postCompensateDeliverAction(conText, payload) {
			postCompensateDeliver(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
	},
};

export default modules;
